import { render, staticRenderFns } from "./specialtyPlan.vue?vue&type=template&id=074390e2&scoped=true"
import script from "./specialtyPlan.vue?vue&type=script&lang=js"
export * from "./specialtyPlan.vue?vue&type=script&lang=js"
import style0 from "./specialtyPlan.vue?vue&type=style&index=0&id=074390e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074390e2",
  null
  
)

export default component.exports